module.exports = __webpack_public_path__ + "static/media/alert.c9d3e69a.svg";